import { colorsPalettes } from "@similarweb/styles";
import { TitlePlaceholderLoader } from "@similarweb/ui-components";
import { Flex, Text } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";
import { FilterBadge } from "app/pages/digital-marketing/generative-ai/llm-tracker/reports/overview-report/what-changed/FilterBadge";

import type { IChangeFilter } from "./types";
import { FiltersCardContainer } from "./WhatChangedWidget.styled";

interface IFiltersCardProps {
    title: string;
    subtitle: string;
    filters: IChangeFilter[];
    emptyText?: string;
    isLoading?: boolean;
}

export const FiltersCard = ({ title, subtitle, filters, emptyText, isLoading }: IFiltersCardProps) => {
    const allZero = filters.every((f) => f.delta === 0);

    return (
        <FiltersCardContainer>
            <Flex
                flexDirection="column"
                justifyContent="space-between"
                width="100%"
                gap="12px"
                minHeight="106px"
                padding="16px 24px"
            >
                {isLoading ? (
                    <TitlePlaceholderLoader />
                ) : (
                    <>
                        <Flex
                            gap="8px"
                            flexDirection="column"
                        >
                            <Text fontVariant="report">{title}</Text>

                            <Text
                                fontVariant="report"
                                color={colorsPalettes.carbon[250]}
                            >
                                {subtitle}
                            </Text>
                        </Flex>
                        {allZero ? (
                            <Text
                                fontVariant="body2"
                                color={colorsPalettes.carbon[250]}
                                as="em"
                            >
                                {emptyText ?? translate("llm.overview_report.what_changed.no_changes")}
                            </Text>
                        ) : (
                            <Flex
                                gap="6px"
                                flexWrap="wrap"
                            >
                                {filters?.map((filter, i) => (
                                    <FilterBadge
                                        key={i}
                                        {...filter}
                                    />
                                ))}
                            </Flex>
                        )}
                    </>
                )}
            </Flex>
        </FiltersCardContainer>
    );
};
